import Vue from 'vue';
import VeeValidate from 'vee-validate';
import ru from 'vee-validate/dist/locale/ru';
import Buefy from 'buefy';
import components from '@/components';
import directives from '@/directives';
import DateHelper from '@/helpers/date';
import { ToastProgrammatic as Toast } from 'buefy';
import api from '@/api';
import lang from '@/lang';

// Buefy
Vue.use(Buefy, {
  defaultTooltipType: 'is-dark',
  defaultTooltipAnimated: true,
  defaultDateFormatter: date => DateHelper.format(date, 'dateYear'),
  defaultDayNames: lang.dayNamesShort,
  defaultMonthNames: lang.monthNames,
  defaultLocale: 'ru-RU',
});

// Vee Validate
Vue.use(VeeValidate, {
  locale: 'ru',
  events: 'input|blur',
  errorBagName: 'vErrors',
  validity: true,
  dictionary: { ru },
});

// API
api.setBaseUrl(process.env.VUE_APP_API || '/api/');
api.onError(error => {
  if (error.code === 20230531) {
    api.logout();
  }
  console.error(error);
  Toast.open({
    type: 'is-danger',
    duration: 5000,
    message: error.code ? error.message.replaceAll('\n', '<br>') : 'Возникла ошибка',
    queue: false,
  });
});

// Directives
Object.keys(directives).forEach(name => {
  Vue.directive(name, directives[name]);
});

// Components
Object.keys(components).forEach(k => {
  Vue.component(components[k].name, components[k]);
});

// Filters
Vue.filter('dateFormat', DateHelper.format);
Vue.filter('dayFormat', DateHelper.dayFormat);
Vue.filter('dateToNow', DateHelper.dateToNow);
